import { create } from 'zustand';

import { resetAudio } from 'utils/sfx/sfx.utils';

export interface AudioStoreType {
  isAllowed: boolean | undefined;
  setIsAllowed: (isAllowed: boolean | undefined) => void;
  toggleIsAllowed: () => void;
  audioLibrary: { [key: string]: HTMLAudioElement | undefined };
  setAudio: (name: string, audio: HTMLAudioElement) => void;
  fadeIn: (name: string, duration?: number) => void;
  fadeOut: (name: string, duration?: number) => void;
}

export const useAudioStore = create<AudioStoreType>((set, get) => ({
  audioLibrary: {},
  setAudio: (name, audio) =>
    set(state => ({ audioLibrary: { ...state.audioLibrary, [name]: audio } })),

  fadeIn: (name /*duration, volume = 1 */) => {
    const audio = get().audioLibrary[name];

    if (!audio) {
      return;
    }
    if (!audio.paused) {
      return;
    }

    resetAudio(audio);
    audio.play();

    // fadeInAudio(audio, duration ?? 4000, volume);
  },

  fadeOut: (name /* duration */) => {
    const audio = get().audioLibrary[name];
    // audio && fadeOutAudio(audio, duration ?? 800);
    audio && audio.pause();
  },

  isAllowed: undefined,
  setIsAllowed: isAllowed => set({ isAllowed }),
  toggleIsAllowed: () => set(state => ({ isAllowed: !state.isAllowed })),
}));
